import React from "react";

const MyBalanceIcon = ({ width, height, color }) => {
  return (
    <svg
      id="Layer_1"
      data-name="Layer 1"
      xmlns="http://www.w3.org/2000/svg"
      xmlnsXlink="http://www.w3.org/1999/xlink"
      width="40"
      height="40"
      viewBox="0 0 40 40"
    >
      <defs>
        <linearGradient
          id="linear-gradient"
          x1="306"
          y1="411"
          x2="306"
          y2="371"
          gradientTransform="matrix(1, 0, 0, -1, -286, 411)"
          gradientUnits="userSpaceOnUse"
        >
          <stop offset="0" stop-color="#9cd4b8" />
          <stop offset="1" stop-color="#3bb67c" />
        </linearGradient>
      </defs>
      <rect fill="url(#linear-gradient)" width="40" height="40" rx="6" />
      <path
        fill="#fff"
        d="M313,398h-1v-1a3,3,0,0,0-.88-2.12A3,3,0,0,0,309,394H299a3,3,0,0,0-3,3v12a3,3,0,0,0,3,3h14a3,3,0,0,0,3-3v-8a3,3,0,0,0-3-3Zm-14-2h10a1,1,0,0,1,1,1v1H299a1,1,0,0,1-.7-.29,1,1,0,0,1,0-1.42A1,1,0,0,1,299,396Zm15,10h-1a1,1,0,1,1,0-2h1Zm0-4h-1a3,3,0,0,0,0,6h1v1a1,1,0,0,1-.29.71,1,1,0,0,1-.7.29H299a1,1,0,0,1-.7-.29A1,1,0,0,1,298,409v-9.17a3,3,0,0,0,1,.17h14a1,1,0,0,1,.7.29,1,1,0,0,1,.29.71Z"
        transform="translate(-286 -383)"
      />
    </svg>
  );
};

export default MyBalanceIcon;
